import {
  Component,
  ChangeDetectionStrategy,
  ContentChild,
  Input,
} from '@angular/core';
import { ListItemDescriptionComponent } from './description/description.component';
import { ListItemIconComponent } from './icon/icon.component';

@Component({
  selector: 'app-list-item',
  templateUrl: './item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemComponent {
  @Input() itemClass = '';

  @ContentChild(ListItemIconComponent) icon: ListItemIconComponent;
  @ContentChild(ListItemDescriptionComponent)
  description: ListItemDescriptionComponent;
}
